<br><br>
<div class="d-flex al-center content-crumbs pb-3">
  <img src="assets/svg/diutin-crumb.svg" class="ms-0 d-none d-md-block pointer" routerLink="/" alt="">
  <div *ngFor="let c of crumbs; let i = index" class="al-center pointer" (click)="goTo(c.url)" [ngClass]=" i < 2 && recipeId > 0 ? ['d-none d-lg-flex']:['d-flex']">
    <img src="assets/svg/arrow-right.svg" class="mx-1 mx-md-3 mx-xl-4" [ngClass]="i == 0 || i == 2 && recipeId > 0 ? ['d-none','d-md-block'] : []" alt="">
    <span class="text-blue fs-4 fw-semibold">{{c?.label}}</span>
  </div>
</div>
<br>